import { render, staticRenderFns } from "./DialogSystemVersion.vue?vue&type=template&id=b67c7b2a&"
import script from "./DialogSystemVersion.vue?vue&type=script&lang=js&"
export * from "./DialogSystemVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports